import { render, staticRenderFns } from "./PrimeCutOffManager.vue?vue&type=template&id=5de868bb&scoped=true"
import script from "./PrimeCutOffManager.vue?vue&type=script&lang=js"
export * from "./PrimeCutOffManager.vue?vue&type=script&lang=js"
import style0 from "./PrimeCutOffManager.vue?vue&type=style&index=0&id=5de868bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de868bb",
  null
  
)

export default component.exports